export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/beta_reading.f5fc5dd.svg";